export default "__VITE_ASSET__O71adkYh__"